import React, { useState, useContext, useEffect, useRef } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";

import Backdrop from "@mui/material/Backdrop";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";

import Avatar from "@mui/material/Avatar";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

import api from "services/api";
import storeApi from "services/store-api";

import qs from "query-string";
import toast from "react-hot-toast";

import colors from "assets/theme/base/colors";
import PhotoGrid from "pages/de/posts/components/PhotoGrid";
import FollowButton2 from "pages/de/posts/components/FollowButton2";

import parse from "html-react-parser";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";

import VisibilityIcon from "@mui/icons-material/Visibility";
import SmsIcon from "@mui/icons-material/Sms";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import Comments from "pages/comment";
import { addProtocol, formatAddress, getAllPostImages } from "utils/helper";
import moment from "moment";
import Divider from "@mui/material/Divider";
import ProductDetailModal from "pages/de/portfolio/components/ProductDetailModal";
import PostImageWrapper from "pages/de/posts/components/PostImageWrapper";

import ColumnGrid from "pages/de/posts/components/ColumnGrid";
import ReactPlayer from "react-player";
import Skeleton from "@mui/material/Skeleton";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

const PostDetailModal = React.forwardRef(
  (
    {
      visible,
      handleClose,
      handleOk,
      post,
      setPost,
      previewMode = false,
      isPublic = false,
      allPosts = [],
    },
    ref
  ) => {
    const [commentCnts, setCommentCnts] = useState(0);
    const [postDetail, setPostDetail] = useState(post);
    const [styleDetailVisible, setStyleDetailVisible] = useState(false);
    const [selectedStyle, setSelectedStyle] = useState(null);
    const [styleImages, setStyleImages] = useState([]);

    const account = useContext(AccountContext);
    const { store } = useContext(StoreContext);
    const navigate = useNavigate();
    // if (ref) {
    //   useImperativeHandle(
    //     ref,
    //     () => ({
    //       contentList,
    //     }),
    //     [setContentList]
    //   );
    // }
    useEffect(() => {
      if (post.id) {
        if (previewMode) {
          setPostDetail(post);
        } else {
          retrievePost(post.id);
        }
        if (visible && !previewMode) {
          updateAmount("view");
        }
      }
    }, [post]);

    useEffect(() => {
      if (postDetail.id) {
        console.log("retrieve comments");
        retrieveComments(postDetail.id);
      }
    }, [postDetail.id]);

    let owner = postDetail?.owner || {};
    let ownerStore = owner?.stores?.[0];
    if (previewMode) {
      owner = account;
      ownerStore = store;
    }
    // const fullName =
    //   owner.first_name || owner.last_name ? `${owner.first_name} ${owner.last_name}` : "";
    const fullName = ownerStore?.name;

    const address = formatAddress(ownerStore?.metadata?.address, true);
    const post_likes = account?.metadata?.post_likes || [];

    const updateAmount = async (mode, delta = 1) => {
      if (!previewMode) {
        try {
          if (mode != "view" && mode != "like") {
            return;
          }

          if (mode == "view") {
            //all users can increase the view count
            await api.post.updateAmount({ id: postDetail?.id, mode, delta });
            setPostDetail((prev) => ({ ...prev, page_view: prev?.page_view + delta }));
          } else if (mode == "like") {
            if (account.id) {
              //only logged in user can like/dislike post
              await api.post.updateAmount({ id: postDetail?.id, mode, delta });
              setPostDetail((prev) => ({ ...prev, like_amount: prev?.like_amount + delta }));
            }
          }
        } catch (err) {
          console.log(err);
        }
      }
    };

    const handleThumbUpToggle = async () => {
      if (previewMode) {
        return;
      } else {
        if (account?.id) {
          const post_likes = account?.metadata?.post_likes || [];
          const findIndex = post_likes.findIndex((x) => x == post.id);
          if (findIndex == -1) {
            post_likes.push(post.id);
            updateAmount("like", 1);
          } else {
            post_likes.splice(findIndex, 1);
            updateAmount("like", -1);
          }
          account.handleUpdate(account.id, { metadata: { post_likes: post_likes } });
        }
      }
    };

    const retrieveComments = async (id) => {
      try {
        api.comment.get(id).then(({ data }) => {
          const topLvlComments = [];
          var cnt = 0;
          for (const comment of data.comments) {
            if (comment.parent_comment_id == "") {
              comment.subComments = [];
              topLvlComments.push(comment);
              ++cnt;
            }
          }
          for (const comment of data.comments) {
            if (comment.parent_comment_id != "") {
              for (const topLvlComment of topLvlComments) {
                if (topLvlComment.id == comment.parent_comment_id) {
                  topLvlComment.subComments.push(comment);
                  ++cnt;
                }
              }
            }
          }
          topLvlComments.sort((a, b) => (a.timestamp < b.timestamp ? 1 : -1));
          for (const comment of topLvlComments) {
            comment.subComments.sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1));
          }
          setCommentCnts(cnt);
          return data;
        });
      } catch (err) {
        toast.error(`get comment failed!`);
        console.log(err);
      }
    };

    const retrievePost = async (id) => {
      try {
        const { data } = await storeApi.post.retrieve(id);
        setPostDetail(data?.post);
      } catch (err) {
        console.log(err);
      }
    };

    const handleClickContentStyle = (item) => {
      setSelectedStyle(item);
      setStyleDetailVisible(true);
      let images = getAllPostImages(post, item.resource_id);
      setStyleImages(images);
    };

    const renderPostContent = (item) => {
      if (item?.type == "text") {
        return (
          <SuiBox
            sx={{
              mt: 1,
              position: "relative",
              width: item?.width || "100%",
            }}
          >
            <SuiTypography
              variant="body1"
              onClick={() => {
                setAddTextItem(item);
              }}
              sx={{ wordBreak: "break-word" }}
            >
              {parse(item?.caption)}
            </SuiTypography>
          </SuiBox>
        );
      } else if (item.type == "grid") {
        return (
          <SuiBox sx={{ width: item?.width || "100%" }}>
            <PhotoGrid
              post={post}
              gridContent={item}
              handleClickContentStyle={handleClickContentStyle}
              readOnly={true}
            />
          </SuiBox>
        );
      } else if (item.type == "column") {
        return (
          <SuiBox>
            <ColumnGrid columnGrid={item} handleClickContentStyle={handleClickContentStyle} />
          </SuiBox>
        );
      } else if (item.type == "video") {
        return item?.video ? (
          <SuiBox sx={{ width: item?.width || "100%" }}>
            <ReactPlayer
              controls={true}
              url={item?.video?.url}
              height="100%"
              style={{ minHeight: 50 }}
              width="100%"
              fallback={
                <Skeleton animation="wave" height={200} width="100%" variant="rectangular" />
              }
            />
          </SuiBox>
        ) : null;
      } else {
        return item?.img ? (
          <SuiBox sx={{ width: item?.width || "100%" }}>
            <PostImageWrapper
              item={item}
              sx={{
                height: "auto",
                width: "100%",
                cursor: item?.resource_id && item?.type == "style" ? "pointer" : "default",
              }}
              handleClick={
                item?.resource_id && item?.type == "style"
                  ? () => handleClickContentStyle(item)
                  : null
              }
              isEdit={false}
            />{" "}
          </SuiBox>
        ) : null;
      }
    };

    return (
      <Backdrop
        open={visible}
        sx={{
          backgroundColor: "rgba(0,0,0,.8)",
          zIndex: (theme) => 99999,
        }}
        onClick={() => handleClose(postDetail)}
      >
        <SuiBox
          className="post-detail-container"
          sx={{ height: "100%", width: "100%", maxWidth: 1400, overflow: "auto" }}
          onClick={(e) => {
            //e.preventDefault();
            e.stopPropagation();
          }}
        >
          <SuiBox sx={{ position: "relative", minWidth: 1000 }}>
            {allPosts.length > 0 ? (
              <SuiButton
                variant="contained"
                iconOnly
                circular
                sx={{
                  position: "fixed",
                  top: "50%",
                  right: 10,
                  zIndex: 4,
                  minWidth: "2.5rem",
                  opacity: 0.6,
                  "&:hover": { opacity: 0.9 },
                }}
                onClick={() => {
                  const index = allPosts.findIndex((x) => x.id == postDetail?.id);
                  if (index > -1) {
                    if (index < allPosts.length - 1) {
                      setPostDetail(allPosts[index + 1]);
                    }
                  }
                }}
              >
                <ArrowForwardIosIcon />
              </SuiButton>
            ) : null}
            {allPosts.length > 0 ? (
              <SuiButton
                variant="contained"
                iconOnly
                circular
                sx={{
                  position: "fixed",
                  top: "50%",
                  left: 10,
                  zIndex: 4,
                  minWidth: "2.5rem",
                  opacity: 0.6,
                  textAlign: "center",
                  margin: "auto",
                  "&:hover": { opacity: 0.9 },
                }}
                onClick={() => {
                  const index = allPosts.findIndex((x) => x.id == postDetail?.id);
                  if (index > -1) {
                    if (index > 0) {
                      setPostDetail(allPosts[index - 1]);
                    }
                  }
                }}
              >
                <ArrowBackIosNewIcon />
              </SuiButton>
            ) : null}

            <SuiBox sx={{ py: 2 }}>
              <SuiBox display="flex" alignItems="center" justifyContent="space-between">
                <SuiBox display="flex" alignItems="center" gap={1}>
                  <Avatar
                    src={ownerStore?.metadata?.avatar}
                    onClick={() =>
                      account?.id
                        ? navigate(`/wall/portfolio/${ownerStore.id}`)
                        : navigate(`/public/portfolio/${ownerStore.id}`)
                    }
                    sx={{ cursor: "pointer" }}
                  />
                  <SuiTypography
                    variant="body1"
                    color="white"
                    onClick={() =>
                      account?.id
                        ? navigate(`/wall/portfolio/${ownerStore.id}`)
                        : navigate(`/public/portfolio/${ownerStore.id}`)
                    }
                    sx={{ cursor: "pointer" }}
                  >
                    {/* {fullName ? fullName + `(${ownerStore?.name})` : ownerStore?.name} */}
                    {ownerStore?.name}
                  </SuiTypography>
                  {ownerStore.id != account?.id && !previewMode ? (
                    <FollowButton2
                      circular
                      size="small"
                      sx={{ width: "100%" }}
                      user={ownerStore}
                      disabled={previewMode}
                      variant="text"
                      color="white"
                    >
                      Follow
                    </FollowButton2>
                  ) : null}
                </SuiBox>
                <SuiTypography
                  variant="h6"
                  textTransform="none"
                  color="white"
                  sx={{
                    fontWeight: "bold",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {postDetail?.title}
                </SuiTypography>
                <IconButton
                  aria-label="close"
                  onClick={() => handleClose(postDetail)}
                  sx={{
                    color: (theme) => theme.palette.grey[100],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </SuiBox>{" "}
            </SuiBox>
            <SuiBox>
              <SuiBox
                sx={{
                  opacity: 1,
                  display: "flex",

                  backgroundColor: "#ffffff",
                }}
              >
                <SuiBox
                  sx={{
                    flexGrow: 1,
                  }}
                >
                  <SuiBox
                    position="relative"
                    sx={{
                      p: 2,
                      minHeight: "60vh",
                      backgroundColor: postDetail?.metadata?.settings?.backgroundColor || "#ffffff",
                    }}
                  >
                    {postDetail?.metadata?.content.map((item, index) => (
                      <SuiBox
                        key={index}
                        sx={{
                          marginBottom: postDetail?.metadata?.settings?.mb + "px",
                        }}
                      >
                        <SuiBox
                          sx={{
                            mx: item?.mx + "px",
                            mt: item?.mx && index == 0 ? item?.mx + "px" : 0,
                            mb:
                              item?.mx && index == post.metadata.content.length - 1
                                ? item?.mx + "px"
                                : 0,
                            position: "relative",
                            display: "flex",
                            justifyContent: item?.alignment || "center",
                          }}
                        >
                          {renderPostContent(item)}
                        </SuiBox>
                        {/*Image Caption*/}
                        {item?.caption != "" && item.type != "text" ? (
                          <SuiBox
                            sx={{
                              mx: item?.mx + "px",
                              mt: 2,
                              position: "relative",
                            }}
                          >
                            <SuiTypography variant="body1" sx={{ wordBreak: "break-word" }}>
                              {parse(item?.caption)}
                            </SuiTypography>
                          </SuiBox>
                        ) : null}
                      </SuiBox>
                    ))}
                  </SuiBox>

                  <SuiBox
                    sx={{
                      height: "200px",
                      width: "100%",
                      backgroundColor: "#121212",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <SuiBox sx={{ textAlign: "center" }}>
                      <IconButton
                        size="medium"
                        sx={{
                          backgroundColor: post_likes.includes(postDetail?.id)
                            ? colors.info.main
                            : "#454545",
                          p: 2,
                          "&:hover": {
                            backgroundColor: post_likes.includes(postDetail?.id)
                              ? colors.info.main
                              : "#454545",
                          },
                        }}
                        onClick={handleThumbUpToggle}
                      >
                        <ThumbUpOutlinedIcon disabled={previewMode} color={"light"} />
                      </IconButton>
                      <SuiBox
                        sx={{
                          my: 2,
                          gap: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <SuiTypography
                          color="light"
                          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                        >
                          {post_likes.includes(postDetail?.id) ? (
                            <ThumbUpIcon
                              color="light"
                              onClick={handleThumbUpToggle}
                              sx={{
                                cursor: previewMode ? "default" : "pointer",
                              }}
                            />
                          ) : (
                            <ThumbUpOutlinedIcon
                              color="light"
                              onClick={handleThumbUpToggle}
                              sx={{
                                cursor: previewMode ? "default" : "pointer",
                              }}
                            />
                          )}
                          <span>{postDetail?.like_amount}</span>
                        </SuiTypography>
                        <SuiTypography
                          color="light"
                          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                        >
                          <VisibilityIcon color="light" />
                          <span>{postDetail?.page_view}</span>
                        </SuiTypography>
                        <SuiTypography
                          color="light"
                          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                        >
                          <SmsIcon color="light" />
                          <span>{commentCnts}</span>
                        </SuiTypography>
                      </SuiBox>
                      <SuiBox>
                        <SuiTypography
                          color="light"
                          variant="body2"
                          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                        >
                          {postDetail?.status == "published"
                            ? `Published: ${moment(postDetail?.metadata?.published_at).format(
                                "MMM DD, YYYY"
                              )}`
                            : "Unpublished"}
                        </SuiTypography>
                      </SuiBox>
                    </SuiBox>
                  </SuiBox>
                </SuiBox>
                <SuiBox
                  sx={{
                    flex: "none",
                    maxWidth: 402,
                    border: "1px solid #efefef",
                    position: "relative",
                  }}
                >
                  <SuiBox
                    sx={{
                      position: "sticky",
                      maxWidth: 400,
                      top: 20,
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <SuiBox
                      sx={{
                        width: "100%",
                        px: 2,
                        pt: 2,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderBottom: "1px solid #efefef",
                      }}
                    >
                      <SuiBox sx={{ width: "100%" }}>
                        <SuiTypography variant="body2" fontWeight="bold">
                          OWNER{ownerStore.id == account?.id ? "(You)" : null}
                        </SuiTypography>
                        <SuiBox display="flex" alignItems="center" gap={1} sx={{ my: 2 }}>
                          <Avatar
                            src={ownerStore?.metadata?.avatar}
                            onClick={() =>
                              account?.id
                                ? navigate(`/wall/portfolio/${ownerStore.id}`)
                                : navigate(`/public/portfolio/${ownerStore.id}`)
                            }
                            sx={{ cursor: "pointer" }}
                          />
                          <SuiBox>
                            <SuiTypography
                              variant="body1"
                              color="dark"
                              src={ownerStore?.metadata?.avatar}
                              onClick={() =>
                                account?.id
                                  ? navigate(`/wall/portfolio/${ownerStore.id}`)
                                  : navigate(`/public/portfolio/${ownerStore.id}`)
                              }
                              sx={{ cursor: "pointer" }}
                            >
                              {ownerStore?.name}
                            </SuiTypography>
                            {address ? (
                              <SuiTypography
                                variant="body2"
                                fontWeight="regular"
                                color="secondary"
                                display="flex"
                                alignItems="center"
                              >
                                <LocationOnIcon />
                                {address}
                              </SuiTypography>
                            ) : null}
                          </SuiBox>
                        </SuiBox>

                        {/* {ownerStore.id != account?.id && !previewMode ? (
                          <FollowButton2
                            circular
                            size="small"
                            sx={{ width: "100%" }}
                            user={ownerStore}
                            disabled={previewMode}
                          >
                            Follow
                          </FollowButton2>
                        ) : null} */}
                        {/* {ownerStore.id == account?.id && !previewMode ? (
                          <SuiButton
                            variant="gradient"
                            circular
                            size="small"
                            sx={{ width: "100%" }}
                            color="info"
                            onClick={() => navigate(`/edit-post/${postDetail?.id}`)}
                          >
                            Edit
                          </SuiButton>
                        ) : null} */}
                      </SuiBox>
                    </SuiBox>
                    <SuiBox sx={{ borderBottom: "1px solid #efefef", py: 1, px: 2 }}>
                      <ImageCardWrapper
                        data={postDetail?.metadata?.coverImage}
                        height={234}
                        width={300}
                        draggable={false}
                      />
                      <SuiTypography
                        variant="body1"
                        textTransform="none"
                        sx={{ lineHeight: 1.2, wordBreak: "break-word", mt: 1 }}
                      >
                        {postDetail?.metadata?.description}
                      </SuiTypography>
                    </SuiBox>

                    <SuiBox
                      sx={{
                        height: "100%",
                        overflow: "auto",
                        width: "100%",
                        px: 2,
                      }}
                    >
                      {account.id ? (
                        <SuiBox py={2} px={1}>
                          <fieldset disabled={previewMode}>
                            <Comments subjectid={postDetail.id} sx={{ height: "100%" }} size="sm" />
                          </fieldset>
                        </SuiBox>
                      ) : (
                        <SuiBox
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "200px",
                          }}
                        >
                          <div style={{ width: 300 }}>
                            <SuiTypography variant="body1" sx={{ ml: 2, mb: 1 }}>
                              Already have an account?
                            </SuiTypography>
                            <SuiButton
                              variant="gradient"
                              color="dark"
                              circular
                              sx={{ width: "100%" }}
                              onClick={() => navigate("/login")}
                              size="small"
                            >
                              Sign In
                            </SuiButton>
                            <SuiBox position="relative" py={0.25}>
                              <Divider />
                              <SuiBox
                                bgColor="white"
                                position="absolute"
                                top="50%"
                                left="50%"
                                px={1.5}
                                lineHeight={1}
                                sx={{ transform: "translate(-50%, -60%)" }}
                              >
                                <SuiTypography
                                  variant="button"
                                  fontWeight="medium"
                                  color="secondary"
                                >
                                  or
                                </SuiTypography>
                              </SuiBox>
                            </SuiBox>
                            <SuiButton
                              variant="gradient"
                              color="info"
                              circular
                              sx={{ width: "100%" }}
                              onClick={() => navigate("/register")}
                              size="small"
                            >
                              Register
                            </SuiButton>
                          </div>
                        </SuiBox>
                      )}
                    </SuiBox>
                  </SuiBox>
                </SuiBox>
              </SuiBox>
            </SuiBox>
          </SuiBox>
          {styleDetailVisible && selectedStyle ? (
            <ProductDetailModal
              visible={styleDetailVisible}
              handleClose={() => setStyleDetailVisible(false)}
              productId={selectedStyle?.resource_id}
              styleImages={styleImages}
            />
          ) : null}
        </SuiBox>
      </Backdrop>
    );
  }
);

export default PostDetailModal;
